<template >
  <div v-if="initialized">
    <notifications group="system" position="top right" :ignoreDuplicates="true" />
    <main class="main">
      <router-view></router-view>
    </main>
  </div>
</template>

<style lang="scss">
.switch-protokol .switch-input:checked + .switch-slider {
  background: linear-gradient(135deg, #6c80ff, #764ba2);
  border: none;
}

.dark-mode {
  .navbar-nav .nav-link:hover {
    color: #ccc;
  }

  .navbar-nav .nav-link.active {
    color: #ccc;
  }
}

.bi-house {
  &:hover {
    color: #6c80ff;
  }

  cursor: pointer;
}

a.dropdown-item i.fa.fa-star-o {
margin-left: 10px;
}

a.icon-holder {
  right: 10px;
  top: 5px;
  position: absolute;
  font-size: 20px;
  padding-left: 10px;
  padding-right: 10px;
  z-index: 10;
}

.sidebar-divider {
  display: block !important;
  background-color: var(--bg-card);
}
</style>

<script>
import { Header as AppHeader, SidebarToggler, Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav,Breadcrumb, Aside as AppAside, AsideToggler, Footer as TheFooter } from '@/components/ui/vue/src'
import SidebarNavItem from '@/components/ui/vue/src'
import Projects from './Projects'
import AppHeaderDropdown from './DefaultHeaderDropdownAccnt'
import ProjectCreate from '../views/projects/Create'
import { Switch as cSwitch } from '@coreui/vue'
import Input from '@/components/form/Input'
import _ from 'lodash'
import RenderEvent from '../components/integrations/RenderEvent'

export default {
  name: 'StandaloneContainer',
  components: {
    AsideToggler,
    AppHeader,
    AppSidebar,
    AppAside,
    TheFooter,
    Projects,
    Breadcrumb,
    AppHeaderDropdown,
    SidebarForm,
    SidebarFooter,
    SidebarToggler,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    ProjectCreate,
    cSwitch,
    InputField: Input,
    RenderEvent,
    SidebarNavItem,
  },
  data () {
    return {
      ready: false,
      componentsReady: false,
      doesntBelongToProject: false,
      noWorkspace: false,
      projectInfo: null,
      appUrl: null,
      createWorkspace: {
        modal: false,
        name: ''
      },
      errors: [],
      menu: [],
      initialized: false,
      subscriptionAlert: null
    }
  },
  computed: {
    currentProjectName() {
      if (this.$store.getters.getCurrentProject) {
        return _.truncate(this.$store.getters.getCurrentProject.name, {length: 15})
      }
    },

    name () {
      return this.$route.name
    },
    
    list () {
      return this.$route.matched.filter((route) => {
        return route.name || route.meta.label
      })
    },

    currentEnv: {
      get() {
        return this.$store.getters.getCurrentEnv == 'live'
      },

      set(val) {
        this.$store.dispatch("setCurrentEnv", val ? "live" : "dev").then(() => {
          this.reRender()
        })
      }
    },
  },

  methods: {
    sendErrorReport() {
      this.$http.post("/v1/system/report", this.serverError).then(resp => {
        this.$mainDialog.msgBoxOk(this.$t("thanksFeedback"))
      })
    },

    projectCreated() {
      this.$router.go('/admin/dashboard');
    },

    fieldError(error) {
        let found = this.errors.find((i, e) => {
            return i.field == error.field
        })

        if (found === undefined) {
            this.errors.push(error)
        } else {
            this.errors.map(e => {
                if (found.field == e.field)
                    e.error = error.error
            })
        }
    },

    checkForErrors() {
        return this.errors.find((i, e) => {
            return i.error
        })
    },

    init() {
      this.$store.dispatch("fetchProjects").then((projects) => {
        let currentProject = projects.find(p => {
          return p.uuid == localStorage.getItem("current_project_uuid")
        })

        if (currentProject == null) {
          this.$store.commit("SET_CURRENT_PROJECT", projects[0])
          currentProject = projects[0]
        } else {
          let prj = projects.find((e) => {
            return e.uuid == currentProject.uuid
          })

          this.$store.commit("SET_CURRENT_PROJECT", prj)
        }

        this.$store.dispatch('setUser')
        this.$store.dispatch('fetchClaims')

        this.initialized = true
      })
    },

    backToHome() {
      this.$router.push("/")
    }
  },

  created() {
    this.init();
  },

  async mounted() {
    this.$store.dispatch("fetchPermissions").then(() => {
      if (!this.$can('dev env_access')) {
        this.$store.dispatch("setCurrentEnv", "live")
      }
    });

    localStorage.setItem("run_mode", "platform");
    localStorage.setItem("current_theme", "dark");
  }
}
</script>
